// extracted by mini-css-extract-plugin
export default {"slider":"LogoCreator_slider__54aYD","labelAvatar":"LogoCreator_labelAvatar__RmQmN","labelFile":"LogoCreator_labelFile__dmstL","breakLine":"LogoCreator_breakLine__u7OeF"};